export const getURL = (item: string): string => {
    const isYoutube = item.split('youtube').length > 1;
    const isYoutubeShort = item.split('youtu.be').length > 1;
    let link = item;
    if (isYoutube) {
        link = `https://www.youtube.com/embed/${item.split('=')[1]}`;
    }
    if (isYoutubeShort) {
        link = `https://www.youtube.com/embed/${item.split('.be/')[1]}`;
    }
    return link;
};
